import Konva from 'konva'
import _ from 'lodash'

function loadImage(url) {
  return new Promise((resovle, reject) => {
    const image = new Image()
    image.onload = function() {
      resovle(image)
    }
    image.onerror = function() {
      reject()
    }
    image.crossOrigin = 'Anonymous'
    const stamp = /^data:image\/(png|jpeg|jpg);base64/.test(url)
      ? ''
      : '?time=' + Date.now()
    image.src = url + stamp
  })
}

function loadImages(urls) {
  return Promise.all(urls.map(url => loadImage(url)))
}

function createContainer(images) {
  return images.map(img => {
    const container = document.createElement('div')
    container.style.width = `${img.width}px`
    container.style.height = `${img.height}px`
    return container
  })
}

async function createKonvaImage({ urls, hasRgb }) {
  if (urls.some(item => !item)) {
    throw new Error('url 为空')
  }
  const imgs = await loadImages(urls)
  const containers = createContainer(imgs)
  const filters = [Konva.Filters.Blur, Konva.Filters.HSL]

  if (hasRgb) {
    filters.push(Konva.Filters.RGB)
  }

  return imgs.map((img, index) => {
    const stage = new Konva.Stage({
      container: containers[index],
      width: img.width,
      height: img.height
    })
    const layer = new Konva.Layer()

    const konvaImage = new Konva.Image({
      image: img,
      x: 0,
      y: 0
    })
    konvaImage.cache()
    konvaImage.filters(filters)
    layer.add(konvaImage)
    stage.add(layer)
    return { konvaImage, stage }
  })
}

export default async function filter({ urls, filters }) {
  console.log(filters)
  const hasRgb =
    _.isNumber(filters.red) &&
    _.isNumber(filters.green) &&
    _.isNumber(filters.blue)
  const images = await createKonvaImage({ urls, hasRgb })
  const konvaImages = images.map(item => item.konvaImage)
  const stages = images.map(item => item.stage)

  if (Array.isArray(konvaImages)) {
    konvaImages.forEach(image => {
      _.each(filters, (value, key) => {
        // blur 也当做 blurRadius 处理
        if (key === 'blur') {
          image.blurRadius(parseFloat(value))
        } else {
          image[key](parseFloat(value))
        }
      })
    })
    const newImages = stages.map((stage, index) => {
      const config = {}
      if (/(\.jpg|\.jpeg)$/.test(urls[index])) {
        config.mimeType = 'image/jpeg'
        config.quality = 0.6
      }
      return stage.toDataURL({ pixelRatio: 1, ...config })
    })
    return newImages
  }
}
